export default __webpack_public_path__ + "static/media/guide11.03b078b2.png";